let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3PDLb")).then(() => parcelRequire('5SbPw'));